import UserTable from './components/UserTable'
import SearchBar from './components/SearchBar'

const App = () => {

  return (
    <>
      <SearchBar />
      <UserTable />
    </>
  )
}

export default App
